// extracted by mini-css-extract-plugin
module.exports = {"Header":"Header_Header__2JsH0","companyName":"Header_companyName__1ksZU"};